import { AppState } from '../../redux'

const getDashboardFilters = (state: AppState) => state.dashboard.filters

export { getDashboardFilters }
